import Cookies from 'js-cookie';

const $ = window.jQuery;

export default new class {
  constructor() {
    this.selectors = {
      close: '.js-message-trigger',
      message: '.js-message',
    };

    this.init();
  }

  init() {
    this.bindCloseEvent();
  }

  bindCloseEvent() {
    $(document).on('click', this.selectors.close, event => {
      const $parent = $(event.currentTarget).parents(this.selectors.message);
      const postId = $parent.data('post');
      $parent.slideUp(() => {
        Cookies.set(`hide-post-${postId}`, postId);
      });
    });
  }
}();



// WEBPACK FOOTER //
// ./src/scripts/modules/messages.js